import { css } from 'emotion';

import getFontStyles from '../../../../lib/styles/getFontStyles';

import { TPADeviceType } from '@wix/podcasts-common/dist/tpa';
import {
  ISettingsColors,
  ISettingsFonts,
} from '@wix/podcasts-common/dist/settings';

interface IGetStylesArgs {
  colors: ISettingsColors;
  fonts: ISettingsFonts;
  deviceType: TPADeviceType;
}

function getStyles({ colors, fonts, deviceType }: IGetStylesArgs) {
  return {
    errorWrapper: css({
      backgroundColor: colors.main.headerBackgroundColor,
    }),
    errorIcon: css({
      color: colors.main.headerTitleColor,
    }),
    errorTitle: css({
      color: colors.main.headerTitleColor,
      ...getFontStyles(fonts.main.headerTitleFont),
      ...{
        [TPADeviceType.DESKTOP]: {
          fontSize: 38,
        },
        [TPADeviceType.MOBILE]: {
          fontSize: 22,
        },
      }[deviceType],
    }),
  };
}

export default getStyles;
